import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import {
  HeaderSection as StyledHeaderSection,
  HeaderInfoContainer,
  HeaderTextContainer,
  BackButton,
} from '../../../styles/UnitsMappingStyles';

export interface HeaderSectionProps {
  onBackClick: () => void;
  isAddingUnits?: boolean;
}

const HeaderSection: React.FC<HeaderSectionProps> = memo(({ onBackClick, isAddingUnits = false }) => {
  const { t } = useTranslation();

  const title = isAddingUnits 
    ? t('CHANNELS.ADD_UNITS', 'إضافة وحدات')
    : t('CHANNELS.UNITS_MAPPING.TITLE', 'دمج الوحدات');
    
  const description = isAddingUnits
    ? t('CHANNELS.ADD_UNITS_DESC', 'قم بإضافة وحدات جديدة من القنوات المختلفة.')
    : t('CHANNELS.UNITS_MAPPING.DESCRIPTION', 'قم بمطابقة الوحدات المستوردة من القنوات المختلفة لضمان توحيد بيانات العقار.');

  return (
    <StyledHeaderSection>
      <HeaderInfoContainer>
        <HeaderTextContainer>
          <Typography
            variant="h3"
            sx={{
              fontSize: '20px',
              fontWeight: 700,
              color: '#262626',
              fontFamily: '"IBM Plex Sans Arabic", sans-serif',
              lineHeight: '28px',
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: '16px',
              color: '#666',
              fontFamily: '"IBM Plex Sans Arabic", sans-serif',
              lineHeight: '24px',
            }}
          >
            {description}
          </Typography>
        </HeaderTextContainer>
      </HeaderInfoContainer>

      <BackButton onClick={onBackClick}>
        {isAddingUnits
          ? t('CHANNELS.UNITS_MAPPING.BACK_TO_PROPERTIES', 'العودة إلى إدارة الممتلكات')
          : t('CHANNELS.UNITS_MAPPING.BACK_TO_CHANNELS', 'العودة إلى الصفحة الرئيسية')}
      </BackButton>
    </StyledHeaderSection>
  );
});

HeaderSection.displayName = 'HeaderSection';

export default HeaderSection;
